import gql from 'graphql-tag'

export const captchaConfig = gql`
  {
    captchaConfig {
      forms {
        code
        status
      }
      public_key
    }
  }
`
